// Mock data for KNOTS Wedding Planner

export const testimonials = [
  {
    id: 1,
    name: "Sarah & Michael Chen",
    location: "Jakarta",
    date: "December 2025",
    review:
      "KNOTS transformed our vision into a breathtaking reality. Every detail was meticulously curated, from the floral arrangements to the seamless coordination on our wedding day. Their professionalism and attention to cultural nuances made our celebration truly unforgettable.",
    rating: 5,
  },
  {
    id: 2,
    name: "Dinda & Arief Wijaya",
    location: "Bandung",
    date: "November 2025",
    review:
      "Choosing KNOTS was the best decision we made for our Sangjit and wedding reception. They honored our traditional ceremony with modern elegance, creating a sophisticated atmosphere that our families still talk about. Absolutely flawless execution.",
    rating: 5,
  },
  {
    id: 3,
    name: "Jessica & David Tanuwijaya",
    location: "Jakarta",
    date: "October 2025",
    review:
      "From our first consultation to the final farewell, KNOTS demonstrated unparalleled expertise in luxury wedding planning. Their vendor network is exceptional, and their day-of coordination allowed us to be fully present in our celebration. Worth every moment.",
    rating: 5,
  },
];

export const services = [
  {
    id: 1,
    title: "Wedding Planner",
    description:
      "Comprehensive planning from concept to celebration, ensuring every detail reflects your unique story.",
    features: [
      "Financial Budgeting",
      "Wedding Timeline & Monitoring Preparation",
      "Vendor Suggestion, Coordination & Negotiation Assistance",
      "Unlimited Consultations via WhatsApp",
      "Unlimited Meetings (as needed)",
      "Holy Matrimony Rehearsal (as needed)",
      "Includes Engagement & Wedding Organizer Services",
    ],
  },
  {
    id: 2,
    title: "Wedding Organizer",
    description:
      "Expert day-of coordination ensuring a seamless, stress-free celebration for you and your guests.",
    features: [
      "Financial Budgeting",
      "Vendor Suggestions",
      "Unlimited Consultations via WhatsApp",
      "Rundown Arrangement & Detail Coordination",
      "Holy Matrimony Rehearsal (as needed)",
      "Vendor Coordination for Technical Meeting (H-1 month)",
      "Family Coordination for Event Details",
    ],
  },
  {
    id: 3,
    title: "Engagement Organizer",
    description:
      "Thoughtful coordination for your engagement celebration, honoring tradition with modern elegance.",
    features: [
      "Vendor Suggestions",
      "Unlimited Consultations via WhatsApp",
      "Rundown Arrangement & Detail Coordination",
      "Vendor Coordination for Technical Meeting (H-2 weeks)",
      "Family Coordination for Event Details",
    ],
  },
];

export const galleryImages = [
  {
    id: 1,
    url: "./img/portfolio-1.jpg",
    alt: "Luxury wedding stage decoration",
    category: "stage",
  },
  {
    id: 2,
    url: "./img/portfolio-2.jpg",
    alt: "Elegant wedding bouquet",
    category: "decoration",
  },
  {
    id: 3,
    url: "./img/portfolio-3.jpg",
    alt: "Elegant wedding table setting",
    category: "table",
  },
  {
    id: 4,
    url: "./img/portfolio-4.jpg",
    alt: "Wedding table decoration details",
    category: "table",
  },
  {
    id: 5,
    url: "./img/portfolio-5.jpg",
    alt: "Wedding ceremony floral arch",
    category: "ceremony",
  },
  {
    id: 6,
    url: "./img/portfolio-6.jpg",
    alt: "Floral ceremony decoration",
    category: "ceremony",
  },
];

export const faqs = [
  {
    id: 1,
    question:
      "What is the difference between your Wedding Planner and Wedding Organizer services?",
    answer:
      "Our Wedding Planner service is a full-scale partnership where we guide you through conceptualization, vendor curation, and budget management from day one. The Wedding Organizer service is focused on precision execution, where we step in during the final weeks to take over vendor liaison and manage the day-of timeline flawlessly.",
  },
  {
    id: 2,
    question: "What exactly is included in your Engagement Organizer service?",
    answer:
      "Our specialized Engagement Organizer service honors traditional engagement protocols while adding a touch of modern luxury. It includes traditional ceremony rundown planning, vendor coordination for specialized items, family coordination, and on-site management to ensure the celebration is performed perfectly.",
  },
  {
    id: 3,
    question: "Do you handle weddings outside Jakarta and Tangerang?",
    answer:
      "Yes! We also serve couples outside Jakarta and Tangerang, bringing our signature blend of meticulous planning and flawless execution to your celebration, wherever you choose to celebrate your special day.",
  },
  {
    id: 4,
    question: "How do you help couples stay within their wedding budget?",
    answer:
      "Budget management is a core pillar of our service. We provide a transparent draft budget early in the process and use our extensive vendor network to negotiate preferred pricing and incentives for our clients, ensuring you get the best value without compromising on quality.",
  },
];

export const contactInfo = {
  email: "knots.wo@gmail.com",
  whatsapp: "0819 3085 3332",
  instagram: "knots.weddingplanner",
  locations: ["Jakarta", "Tangerang"],
};
